export default __webpack_public_path__ + "static/media/insta10.7dcb40eb.webp";